// test1556
(1556 && 0);
